import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import OrderHall from '@/views/OrderHall.vue'
import Mine from '@/views/Mine.vue'
import MyOrders from '@/views/MyOrders.vue'
import ServiceCenter from '@/views/ServiceCenter.vue'
import OnlineContract from '@/views/OnlineContract.vue'
import OrderDetail from '@/views/OrderDetail.vue'
import StartService from '@/views/StartService.vue'
import DeliverVehicle from '@/views/DeliverVehicle.vue'
import { isLoggedIn } from '@/utils/auth'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => this.currentRoute)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(() => this.currentRoute)
}

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: () => isLoggedIn() ? '/home' : '/login' },
  { path: '/login', name: 'Login', component: Login, meta: { title: '登录' } },
  { path: '/home', name: 'Home', component: Home, meta: { title: '首页', tab: true } },
  { path: '/order-hall', name: 'OrderHall', component: OrderHall, meta: { title: '订单大厅', tab: true } },
  { path: '/mine', name: 'Mine', component: Mine, meta: { title: '我的', tab: true } },
  { path: '/my-orders', name: 'MyOrders', component: MyOrders, meta: { title: '我的订单' } },
  { path: '/order-detail', name: 'OrderDetail', component: OrderDetail, meta: { title: '订单详情' } },
  { path: '/start-service', name: 'StartService', component: StartService, meta: { title: '提车' } },
  { path: '/deliver-vehicle', name: 'DeliverVehicle', component: DeliverVehicle, meta: { title: '交车' } },
  { path: '/service-center', name: 'ServiceCenter', component: ServiceCenter, meta: { title: '客服中心' } },
  { path: '/online-contract', name: 'OnlineContract', component: OnlineContract, meta: { title: '在线合同' } }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !isLoggedIn()) {
    next('/login')
  } else {
    next()
  }
})

router.onError(() => {})

export default router
